import React from 'react';

import { Avatar as AntAvatar } from 'antd';
import { AvatarProps } from 'antd/lib/avatar';
import { AvatarSize } from 'antd/lib/avatar/SizeContext';

import cn from 'classnames';
import styles from './Avatar.module.scss';

import { Group } from './Group';

export interface IAvatarProps extends AvatarProps {
  /** Shape of avatar */
  shape?: 'circle' | 'square';
  /** The size of the avatar */
  size?: AvatarSize;
  /** Letter type unit distance between left and right sides */
  gap?: number;
  /** The address of the image for an image avatar or image element */
  src?: React.ReactNode;
  /** A list of sources to use for different screen resolutions */
  srcSet?: string;
  /** Whether the picture is allowed to be dragged */
  draggable?: boolean;
  /** Icon to be used in avatar */
  icon?: React.ReactNode;
  className?: string;
  /** This attribute defines the alternative text describing the image */
  alt?: string;
  /** Handler when img load error, return false to prevent default fallback behavior */
  onError?: () => boolean;
}

type TAvatar = React.FC<IAvatarProps> & {
  Group: typeof Group;
};

/**
 * Avatars can be used to represent people or objects. It supports images, Icons, or letters.
 */
export const Avatar: TAvatar = ({ className, ...props }) => (
  <AntAvatar className={cn(styles.Avatar, className)} {...props} />
);

Avatar.Group = Group;
